var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Unhandled Task - "+_vm._s(_vm.item.category))]),_c('p',[_vm._v(_vm._s(_vm.item.description))]),_c('p',[_vm._v("This type of task is currently not handled.")]),_c('pre',[_vm._v(_vm._s(_vm.json))]),_c('button',{on:{"click":_vm.ignore}},[_vm._v("Ignore")])])
}
var staticRenderFns = []

export { render, staticRenderFns }